// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".direct-signup-modal{text-align:center}.direct-signup-modal-header{display:flex;align-items:center;justify-content:center}.direct-signup-brand-icon{width:40px;height:40px;border-radius:100%}.direct-signup-logo{width:100px}", ""]);
// Exports
module.exports = exports;
